<template>
  <div>
    <!-- 左侧 -->
    <div class="left">
      <!-- 搜索部分 -->
      <div class="PolicySearch">
        <form>
          <!-- 搜索部分第一行 -->
          <div class="row1">
            <!-- 搜索栏 -->
            <!-- 普通搜索 -->
            <div class="searchBar">
              <form action="">
                <input
                  type="text"
                  placeholder="请输入关键字查询"
                  v-model="normalSearch.searchKey"
                />
                <input type="button" value="" @click="btnNormalSeach" />
              </form>
            </div>
            <!-- 高级搜索 -->
            <div class="advanceSearch">
              <span class="sign">高级选择</span>
              <span class="btnAdvance" @click="drawer = true"> </span>

              <!-- 高级搜索下拉框 -->
              <el-drawer
                title="高级搜索"
                :visible.sync="drawer"
                :direction="direction"
                size="53%"
                modal
              >
                <div class="advanceBody">
                  <!-- 搜索结果部分 -->
                  <div class="searchResult">
                    <span class="Title fl">搜索结果:</span>
                    <div class="allKey fl">
                      包含以下全部的关键词：
                      <input type="text" v-model="advanceSeach.allKey" />
                    </div>
                    <div style="clear: both"></div>
                    <div class="totalKey fl">
                      包含以下的完整关键词：
                      <input type="text" v-model="advanceSeach.totalKey" />
                    </div>
                    <div style="clear: both"></div>

                    <div class="anyKey fl">
                      包含以下任意一个关键词：
                      <input type="text" v-model="advanceSeach.anyKey" />
                    </div>
                    <div style="clear: both"></div>

                    <div class="noKey fl">
                      不包含以下关键词：
                      <input type="text" v-model="advanceSeach.noKey" />
                    </div>
                    <div style="clear: both"></div>
                  </div>

                  <!-- 时间范围部分 -->
                  <div class="dateArea">
                    <span class="Title">时间范围:</span>
                    <el-date-picker
                      v-model="advanceSeach.data"
                      type="daterange"
                      align="right"
                      unlink-panels
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      :picker-options="pickerOptions"
                      style="margin-left: 40px"
                    >
                    </el-date-picker>
                  </div>

                  <!-- 排序方式部分 -->
                  <div class="sortOrder">
                    <span class="Title"> 排序方式:</span>
                    <el-radio-group
                      v-model="advanceSeach.isDate"
                      style="margin-left: 40px"
                    >
                      <el-radio :label="1">按相关度排序</el-radio>
                      <el-radio :label="2">按时间排序</el-radio>
                    </el-radio-group>
                  </div>

                  <!-- 搜索位置部分 -->
                  <div class="searchPosition">
                    <span class="Title"> 搜索位置: </span>
                    <el-radio-group
                      v-model="advanceSeach.isTitle"
                      style="margin-left: 35px"
                    >
                      <el-radio :label="1">任何地方</el-radio>
                      <el-radio :label="2">仅标题</el-radio>
                    </el-radio-group>
                  </div>

                  <!-- 开始搜索 -->
                  <input
                    class="advanceSeachBtn"
                    type="submit"
                    value="开始搜索"
                  />
                </div>
              </el-drawer>
            </div>
          </div>
          <!-- 搜索部分第二行 -->
          <div class="row2">
            <div class="policySelect_1">
              <div class="row1">
                <div
                  class="companyTab fl"
                  :class="{ active: isCompany }"
                  @click="btn_isCompany"
                >
                  企业政策
                </div>
                <div
                  class="personalTab fl"
                  :class="{ active: !isCompany }"
                  @click="btn_isCompany"
                >
                  个人政策
                </div>
                <div class="search fl">
                  <div class="btn">
                    选择下方分类进行查询，结果更精确哦！<el-button
                      type="primary"
                      icon="el-icon-search"
                      >政策</el-button
                    >
                  </div>
                </div>
              </div>
              <div class="company" :class="{ hide: !isCompany }">
                <div class="tab fl">企业类型:</div>
                <div class="selection fl">
                  <el-radio-group v-model="companyType">
                    <el-radio-button label="高新技术企业"></el-radio-button>
                    <el-radio-button label="外资企业"></el-radio-button>
                    <el-radio-button label="中小企业"></el-radio-button>
                    <el-radio-button label="民营企业"></el-radio-button>
                    <el-radio-button label="国有企业"></el-radio-button>
                    <el-radio-button label="事业单位"></el-radio-button>
                    <el-radio-button label="社会组织"></el-radio-button>
                  </el-radio-group>
                </div>
                <div class="clear"></div>
                <div class="tab tab_type fl">政策类型:</div>
                <div class="selection fl">
                  <el-radio-group v-model="policyType">
                    <el-radio-button label="准入"></el-radio-button>
                    <el-radio-button label="资质"></el-radio-button>
                    <el-radio-button label="专利"></el-radio-button>
                    <el-radio-button label="贷款"></el-radio-button>
                    <el-radio-button label="投资"></el-radio-button>
                    <el-radio-button label="招录"></el-radio-button>
                    <el-radio-button label="税费"></el-radio-button>
                    <el-radio-button label="注销"></el-radio-button>
                    <el-radio-button label="发展规划"></el-radio-button>
                    <el-radio-button label="投资审批"></el-radio-button>
                    <el-radio-button label="人力资源"></el-radio-button>
                    <el-radio-button label="融资信贷"></el-radio-button>
                    <el-radio-button label="抵押质押"></el-radio-button>
                    <el-radio-button label="司法公正"></el-radio-button>
                    <el-radio-button label="科技创新"></el-radio-button>
                    <el-radio-button label="教育培训"></el-radio-button>
                    <el-radio-button label="新闻出版"></el-radio-button>
                    <el-radio-button label="文体旅游"></el-radio-button>
                  </el-radio-group>
                </div>
                <div class="fl"></div>
                <div class="clear"></div>
              </div>
              <div class="personal" :class="{ hide: isCompany }">
                <div class="tab fl">我是:</div>
                <div class="selection fl">
                  <el-radio-group v-model="Iam">
                    <el-radio-button label="高校毕业生"></el-radio-button>
                    <el-radio-button label="在职人员"></el-radio-button>
                    <el-radio-button label="待业人员"></el-radio-button>
                    <el-radio-button label="老年人"></el-radio-button>
                    <el-radio-button label="儿童"></el-radio-button>
                    <el-radio-button label="青少年"></el-radio-button>
                    <el-radio-button label="残疾人"></el-radio-button>
                    <el-radio-button label="农民"></el-radio-button>
                    <el-radio-button label="军人"></el-radio-button>
                    <el-radio-button label="港澳台侨"></el-radio-button>
                    <el-radio-button label="外国人"></el-radio-button>
                  </el-radio-group>
                </div>
                <div class="clear"></div>
                <div class="tab fl">我找:</div>
                <div class="selection fl">
                  <el-radio-group v-model="lookFor">
                    <el-radio-button label="出生"></el-radio-button>
                    <el-radio-button label="入学"></el-radio-button>
                    <el-radio-button label="工作"></el-radio-button>
                    <el-radio-button label="购房"></el-radio-button>
                    <el-radio-button label="结婚"></el-radio-button>
                    <el-radio-button label="创业"></el-radio-button>
                    <el-radio-button label="生活"></el-radio-button>
                    <el-radio-button label="就医"></el-radio-button>
                    <el-radio-button label="养老"></el-radio-button>
                    <el-radio-button label="生育"></el-radio-button>
                    <el-radio-button label="收养"></el-radio-button>
                    <el-radio-button label="户籍办理"></el-radio-button>
                    <el-radio-button label="教育科研"></el-radio-button>
                    <el-radio-button label="就业创业"></el-radio-button>
                    <el-radio-button label="证件证照"></el-radio-button>
                    <el-radio-button label="职业资格"></el-radio-button>
                    <el-radio-button label="知识产权"></el-radio-button>
                    <el-radio-button label="人力资源"></el-radio-button>
                    <el-radio-button label="房屋管理"></el-radio-button>
                    <el-radio-button label="国土资源"></el-radio-button>
                  </el-radio-group>
                </div>
                <div class="clear"></div>
              </div>
            </div>
          </div>
          <!-- 搜索部分第三行 -->
          <div class="row3">
            <!-- 相关结果个数 -->
            <div class="fl">
              相关结果约<span class="total">{{ " " + total }}</span> 个
            </div>
            <!-- 限制条件1 -->
            <div class="fl limit1">
              <span
                :class="{ bottom_border: normalSearch.isDate == false }"
                @click="limit1()"
                >按相关度排序</span
              >/<span
                :class="{ bottom_border: normalSearch.isDate == true }"
                @click="limit1()"
                >按日期排序</span
              >
            </div>
            <!-- 限制条件2 -->
            <div class="fl limit2">
              <span
                :class="{ bottom_border: normalSearch.isTitle == false }"
                @click="limit2()"
                >按全文检索</span
              >/<span
                :class="{ bottom_border: normalSearch.isTitle == true }"
                @click="limit2()"
                >按标题检索</span
              >
            </div>
            <!-- 限制条件3 -->
            <div class="fr limit3">
              <el-dropdown>
                <span class="el-dropdown-link">
                  <span v-if="normalSearch.date == null">时间不限</span>
                  <span v-else>{{
                    normalSearch.date[0] + "至" + normalSearch.date[1]
                  }}</span>
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    ><el-date-picker
                      v-model="normalSearch.date"
                      type="daterange"
                      align="right"
                      unlink-panels
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      :picker-options="pickerOptions"
                      value-format="yyyy-MM-dd"
                    >
                    </el-date-picker
                  ></el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </form>
      </div>
      <!-- 政策数据 -->
      <ul style="padding: 0">
        <li v-for="count in 5" :key="count">
          <v-policy-result></v-policy-result>
        </li>
      </ul>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[5, 10, 15, 20]"
        :page-size="5"
        layout="total, sizes, prev, pager, next, jumper"
        :total="400"
      >
      </el-pagination>
    </div>
    <div class="right">
      <v-rank></v-rank>
    </div>
  </div>
</template>

<script>
import vPolicyResult from "../LM_2_policy/PolicyResult";

export default {
  name: "App",
  components: {
    vPolicyResult,
  },
  props: {},
  data() {
    return {
      // 控制高级搜索显示与否
      drawer: false,
      // 控制高级搜索区域显示方式
      direction: "ttb",
      // 高级搜索条件
      advanceSeach: {
        allKey: "",
        totalKey: "",
        anyKey: "",
        noKey: "",
        data: "",
        isDate: 1,
        isTitle: 1,
      },
      // 相关结果数
      total: 0,
      // 普通搜索条件
      normalSearch: {
        // 搜索关键字
        searchKey: "",
        // 是否按日期排序
        isDate: false,
        // 是否按标题检索
        isTitle: false,
        // 日期
        date: null,
      },
      // 时间选项
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 366);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      // 单选关键字
      isCompany: true,
      companyType: "",
      policyType: "",
      Iam: "",
      lookFor: "",

      // 分页
      // 当前页
      currentPage: 1,
    };
  },
  watch: {},
  computed: {},
  methods: {
    // 是否按日期排序
    limit1() {
      this.normalSearch.isDate = !this.normalSearch.isDate;
    },
    // 是否按标题检索
    limit2() {
      this.normalSearch.isTitle = !this.normalSearch.isTitle;
    },
    // 点击搜索
    btnNormalSeach() {
      console.log(this.normalSearch);
    },
    // 清空单选关键字
    clearAll() {
      this.release = "";
      this.department = "";
      this.theme = "";
      this.date = "";
    },
    // 点击企业政策
    btn_isCompany() {
      this.isCompany = !this.isCompany;
      this.companyType = "";
      this.policyType = "";
      this.Iam = "";
      this.lookFor = "";
    },
    // 分页
    handleSizeChange() {},
    handleCurrentChange() {},
  },
  created() {},
  mounted() {},
};
</script>

<style lang="less" scoped>
// 删除ie中input的×号
input::-ms-clear {
  display: none;
}
.left {
  float: left;
  width: 873px;
}
.hide {
  display: none;
}

.right {
  float: left;
  width: 360px;
  border-left: 2px solid rgb(16, 115, 183);
}

.PolicySearch {
  .bottom_border {
    border-bottom: 1px solid rgb(16, 115, 183);
  }
  .row1 {
    width: 873px;
    height: 50px;
  }

  .searchBar {
    width: 700px;
    height: 50px;
    /* margin: auto; */
    float: left;

    input {
      box-sizing: border-box;
      // display: inline-block;
      font-size: 20px;
      float: left;
    }

    input[type="text"] {
      width: 570px;
      height: 50px;
      border: 1px solid rgb(16, 115, 183);
      outline: none;
      border-radius: 5px 0 0 5px;
      padding-left: 20px;
      background-color: transparent;
    }

    input[type="button"] {
      width: 130px;
      height: 50px;
      margin-left: -5px;
      border-radius: 5px;
      border: none;
      outline: none;
      cursor: pointer;
      /* background-color: rgb(16, 115, 183); */
      color: #ffffff;
      background-image: url(../../assets/img/search_btn_bg.png);
      background-size: 100% 100% no-repeat;
    }
  }

  .advanceSearch {
    width: 120px;
    height: 25px;
    float: left;
    position: relative;
    top: 10%;
    margin-left: 35px;

    span {
      display: inline-block;
      height: 25px;
      position: relative;
      font-size: 20px;
      color: rgb(16, 115, 183);
      margin-right: 5px;
    }
    .sign {
      top: -25%;
    }
    .btnAdvance {
      display: inline-block;
      width: 25px;
      height: 25px;
      background-image: url(../../assets/img/advanceSearch.png);
      background-size: 100% 100%;
      padding: 0;
      border: none;
      border-radius: 0;
      cursor: pointer;
    }
    /deep/ .el-drawer {
      overflow-y: scroll;
    }
    /deep/ .el-drawer__container {
      background: rgba(51, 50, 50, 0.8);
    }

    /deep/ .el-drawer__header {
      padding-top: 10px;
      padding-left: 15%;
      margin-bottom: 0px;
      span {
        font-size: 20px;
        font-weight: bold;
        width: 82px;
        height: 30px;
        border-bottom: 2px solid rgb(16, 115, 183);
        flex: none;
        margin-right: 80%;
      }
    }
  }

  .row2 {
    .policySelect_1 {
      width: 853px;
      height: 150px;
      background-color: rgb(245, 249, 253);
      border-radius: 5px;
      margin-top: 10px;
      .row1 {
        width: 853px;
        height: 40px;
        .companyTab {
          width: 100px;
          height: 40px;
          border-bottom: 2px solid rgb(16, 115, 183);
          font-size: 18px;
          text-align: center;
          line-height: 40px;
          cursor: pointer;
        }
        .personalTab {
          width: 100px;
          height: 40px;
          border-bottom: 2px solid rgb(16, 115, 183);
          font-size: 18px;
          text-align: center;
          line-height: 40px;
          cursor: pointer;
        }
        .search {
          width: 640px;
          height: 40px;
          border-bottom: 2px solid rgb(16, 115, 183);
          .btn {
            margin-left: 250px;
            line-height: 40px;
            font-size: 14px;
            color: grey;
            /deep/.el-button--primary {
              font-size: 18px;
              height: 40px;
              background-color: rgb(16, 115, 183);
            }
          }
          /deep/.el-button {
            margin-left: 30px;
          }
        }
        .active {
          border-top: 2px solid rgb(16, 115, 183);
          border-left: 2px solid rgb(16, 115, 183);
          border-right: 2px solid rgb(16, 115, 183);
          border-bottom: none;
        }
      }

      .company {
        margin-top: 10px;
        .tab {
          padding-left: 20px;
          width: 80px;
          height: 20px;
          font-weight: bold;
          text-align-last: justify;
          margin-bottom: 10px;
        }
        .tab_type {
          height: 40px;
        }
        .selection {
          width: 700px;
          margin-bottom: 10px;
        }
        /deep/.el-radio-button__inner {
          border: none;
          background: transparent;
          border-right: 1px solid black;
          font-weight: bold;
          padding: 0 10px 0 10px;
          font-size: 15px;
          margin-bottom: 5px;
        }
        /deep/.el-radio-button__orig-radio:checked + .el-radio-button__inner {
          box-shadow: none;
          color: rgb(16, 115, 183);
        }
        /deep/.el-radio-button:last-child .el-radio-button__inner {
          border: none;
        }
      }
      .personal {
        margin-top: 10px;
        .tab {
          padding-left: 20px;
          width: 80px;
          height: 20px;
          font-weight: bold;
          text-align-last: justify;
          margin-bottom: 10px;
        }
        .tab_type {
          height: 40px;
        }
        .selection {
          width: 700px;
          margin-bottom: 10px;
        }
        /deep/.el-radio-button__inner {
          border: none;
          background: transparent;
          border-right: 1px solid black;
          font-weight: bold;
          padding: 0 10px 0 10px;
          font-size: 15px;
          margin-bottom: 5px;
        }
        /deep/.el-radio-button__orig-radio:checked + .el-radio-button__inner {
          box-shadow: none;
          color: rgb(16, 115, 183);
        }
        /deep/.el-radio-button:last-child .el-radio-button__inner {
          border: none;
        }
      }
    }
  }
  .row3 {
    width: 873px;
    height: 25px;
    margin-top: 25px;
    span {
      cursor: pointer;
    }
    .total {
      color: rgb(16, 115, 183);
    }
    .limit1 {
      color: rgb(16, 115, 183);
      margin-left: 100px;
    }
    .limit2 {
      color: rgb(16, 115, 183);
      margin-left: 50px;
    }
    .limit3 {
      color: rgb(16, 115, 183);
      // margin-left: 30px;
      margin-right: 20px;
    }
    .el-dropdown-link {
      cursor: pointer;
      color: rgb(16, 115, 183);
    }
    /deep/.el-dropdown {
      font-size: 16px;
    }
  }

  // 高级搜索
  .advanceBody {
    .Title {
      font-size: 16px;
      font-weight: bold;
      color: rgb(0, 0, 0);
    }
    .searchResult {
      padding: 40px 0 0 15%;
      background-color: rgb(238, 238, 238);

      .allKey {
        margin-left: 40px;
        margin-bottom: 20px;
        input {
          margin-left: 30px;
          height: 25px;
        }
      }
      .totalKey {
        margin-left: 115px;
        margin-bottom: 20px;
        input {
          margin-left: 30px;
          height: 25px;
        }
      }
      .anyKey {
        margin-left: 115px;
        margin-bottom: 20px;
        input {
          margin-left: 15px;
          height: 25px;
        }
      }
      .noKey {
        margin-left: 113px;
        margin-bottom: 20px;
        input {
          margin-left: 65px;
          height: 25px;
        }
      }
    }

    .dateArea {
      padding-left: 15%;
      margin-top: 15px;
    }
    .sortOrder {
      padding-left: 15%;
      margin-top: 15px;
    }
    .searchPosition {
      padding-left: 15%;
      margin-top: 15px;
    }

    .advanceSeachBtn {
      width: 140px;
      height: 40px;
      background-color: rgb(16, 115, 183);
      color: #ffffff;
      font-size: 20px;
      outline: none;
      border: none;
      margin-left: 30%;
      margin-top: 20px;
      cursor: pointer;
    }
  }
}
</style>